import { render } from "./TherapyFormCreate.vue?vue&type=template&id=72fa0198"
import script from "./TherapyFormCreate.vue?vue&type=script&lang=js"
export * from "./TherapyFormCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__